﻿import { ValgStateActionTypes, ValgState, UPDATE_VALG } from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { VeilederUtvekslingAppState } from '..';
import { AnyAction } from 'redux';
import { setVisning } from '../Resultat/Actions';
import VerdensdelValg from '../../Utilities/VerdensdelValg';
import LandOgUniversitetModel from '../../../Shared/Scripts/Models/LandOgUniversitetModel';
import VarighetValg from '../../Utilities/VarighetValg';
import { harValgtLandSomGirRekrutteringsstipendUtveksling } from '../../Utilities/LandMedRekrutteringsstipendUtveksling';

export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export const updateVisning = (): ThunkAction<void, VeilederUtvekslingAppState, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<VeilederUtvekslingAppState, {}, AnyAction>, getState: () => VeilederUtvekslingAppState): void => {
        const currentState = getState();

        const visBoksB = visB(currentState);
        const visBoksC = visC(currentState);
        const visBoksD = visD(currentState);
        const visBoksE = visE(currentState);
        const visBoksFa = visFa(currentState, visBoksE);
        const visBoksFb = visFb(currentState, visBoksD, visBoksE);
        const visUtbetalingsplan = visUtbetPlan(currentState);
        dispatch(setVisning({ visBoksB, visBoksC, visBoksD, visBoksE, visBoksFa, visBoksFb, visUtbetalingsplan }));
    };
};

const visB = (state: VeilederUtvekslingAppState): boolean => {
    if (state.valg.aVarighet !== null && state.valg.aVarighet !== undefined) return true;

    return false;
};

const visC = (state: VeilederUtvekslingAppState): boolean => {
    if (state.valg.bVerdensdel !== null
        && state.valg.bVerdensdel !== undefined
        && (state.valg.bVerdensdel.value === VerdensdelValg.b2_asia
            || state.valg.bVerdensdel.value === VerdensdelValg.b3_europa
            || state.valg.bVerdensdel.value === VerdensdelValg.b4_nordMellomAmerika
            || state.valg.bVerdensdel.value === VerdensdelValg.b5_oseania
            || state.valg.bVerdensdel.value === VerdensdelValg.b6_sorAmerika
            || state.valg.bVerdensdel.value === VerdensdelValg.b1_afrika)
    ) return true;

    return false;
};

// D = skolepenger-boks
const visD = (state: VeilederUtvekslingAppState): boolean => {
    if (state.valg.bVerdensdel === undefined) return false;

    if (state.valg.bVerdensdel !== undefined && state.valg.cLand !== undefined) return true;

    return false;
};

// E = 'velg universitet'-boks
const visE = (state: VeilederUtvekslingAppState): boolean => {

    if (state.valg.dSkolepenger === undefined) return false;

    if (state.valg.dSkolepenger !== undefined && state.valg.dSkolepenger.tillegg) return false; // tillegg = går på BI

    if (state.satser === null) return false;

    //fjerner white space fra string for at parsingen skal fungere som forventet.
    //TODO: fjern evt. tegn som ikke er tall fra strengen.
    const skolePenger: number = parseInt(state.valg.dSkolepenger.value.toString().replace(/\s/g, ''));

    let nevner: number = 1;
    if (state.valg.aVarighet?.value === VarighetValg.valgHost || state.valg.aVarighet?.value === VarighetValg.valgVaar) {
        nevner = 2;
    }

    if (skolePenger <= (state.satser.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevner)) return false;

    // skal alltid spørre om universitet dersom landet har et universitet som gir rett til utvidet stipend i lista
    if (harValgtLandSomHarUniversitetMedUtvidetStipend(state.valg, state.universiteter) && state.valg.dSkolepenger !== undefined) return true;

    return false;
};

const visFa = (state: VeilederUtvekslingAppState, visBoksE: boolean): boolean => {


    if ((state.valg.bVerdensdel?.value === VerdensdelValg.b1_afrika ||
        state.valg.bVerdensdel?.value === VerdensdelValg.b6_sorAmerika) &&
        state.valg.dSkolepenger !== undefined &&
        state.valg.dSkolepenger.id !== 'IngenSkolePenger')
        return true;

    if (state.valg.dSkolepenger !== undefined && state.valg.dSkolepenger.tillegg && state.valg.dSkolepenger.id !== 'IngenSkolePenger') return true;

    if (state.valg.dSkolepenger !== undefined &&
        state.valg.dSkolepenger.id !== 'IngenSkolePenger' &&
        state.valg.cLand !== undefined &&
        state.valg.cLand.id === 'E')
        return true;

    if (state.valg.dSkolepenger !== undefined) {
        const skolePenger: number = parseInt(state.valg.dSkolepenger.value.toString().replace(/\s/g, ''));

        if (state.satser === null) return false;

        let nevner: number = 1;
        if (state.valg.aVarighet?.value === VarighetValg.valgHost || state.valg.aVarighet?.value === VarighetValg.valgVaar) {
            nevner = 2;
        }

        if (skolePenger <= state.satser.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevner)
            return true;

        // har valgt skolepengebeløp over maks men har ikke liste med universiteter  
        if (harValgtLandMedRekrutteringsstipend(state.valg) && !visBoksE && skolePenger > (state.satser.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevner) && state.valg.dSkolepenger?.id !== 'IngenSkolePenger')
            return true;
    }

    if (harValgtLandMedRekrutteringsstipend(state.valg) &&
        state.valg.dSkolepenger !== undefined &&
        state.valg.dSkolepenger?.id !== 'IngenSkolePenger' &&
        state.valg.eUniversitet !== undefined &&
        state.valg.eUniversitet?.toString() !== '')
        return true;

    if (!visBoksE) return false;

    if (state.valg.eUniversitet !== undefined &&
        state.valg.eUniversitet?.toString() !== '' &&
        state.valg.dSkolepenger?.id !== 'IngenSkolePenger')
        return true;

    return false;
};

const visFb = (state: VeilederUtvekslingAppState, visBoksD: boolean, visBoksE: boolean): boolean => {

    if (!visBoksD) return false;

    //viser boks Fb dersom man har valgt afrika og ikke skolepenger.
    if ((state.valg.bVerdensdel?.value === VerdensdelValg.b1_afrika ||
        state.valg.bVerdensdel?.value === VerdensdelValg.b6_sorAmerika) &&
        (state.valg.eUniversitet === undefined &&
            state.valg.dSkolepenger?.id === 'IngenSkolePenger'))
        return true;

    // har valgt "Går på BI" og "Vet ikke"
    if (state.valg.dSkolepenger !== undefined && state.valg.dSkolepenger.tillegg && state.valg.dSkolepenger.id === 'IngenSkolePenger') return true;

    // har valgt "Et annet land" og "Vet ikke"
    if (state.valg.cLand !== undefined && state.valg.cLand.id == "E" && state.valg.dSkolepenger !== undefined && state.valg.dSkolepenger?.id === 'IngenSkolePenger') return true;

    // har valgt et land med rekrutteringsstipend, men som ikke har universitet med utvidet støtte, og "vet ikke"
    if (harValgtLandMedRekrutteringsstipend(state.valg) &&
        !harValgtLandSomHarUniversitetMedUtvidetStipend(state.valg, state.universiteter) &&
        state.valg.dSkolepenger !== undefined &&
        state.valg.dSkolepenger?.id === 'IngenSkolePenger')
        return true;

    // dersom vi har valgt et universitet og "Vet ikke" så vet vi at vi skal vise Fb
    if (state.valg.eUniversitet !== undefined && state.valg.dSkolepenger?.id === 'IngenSkolePenger') {
        return true;
    }

    return false;
};

const visUtbetPlan = (state: VeilederUtvekslingAppState): boolean => {
    return state.valg.visUtbetalingsplan;
}

// "Utvidet stipend"/ tilleggsstipend gitt for visse universitet
const harValgtLandSomHarUniversitetMedUtvidetStipend = (valg: ValgState, universiteter: LandOgUniversitetModel[]): boolean => {
    if (valg.cLand?.id === "E") {
        return false;
    }

    for (let i = 0; i < universiteter.length; i++) {
        if (universiteter[i].Landkode == valg.cLand?.id && universiteter[i].Universitet !== "") {
            return true;
        }
    }

    return false;
}

// "Rekrutteringsstipend"/ tilleggsstipend spesielt for utveksling. Gir et ekstra stipend for visse land.
const harValgtLandMedRekrutteringsstipend = (valg: ValgState) => {

    if (harValgtLandSomGirRekrutteringsstipendUtveksling(valg)) {
        return true;
    }
    return false;

}